import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AdminResolver implements Resolve<boolean> {
  constructor(private _coreMenuService: CoreMenuService){}
  resolve(): Observable<boolean> {
    this._coreMenuService.setCurrentMenu('admin_main');
    return of(true);
  }
}
